export default "/images/Pro-17.png?880d4a9b5e2be50d14a19af769d32787";